import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=0c5f5a93"
import script from "./LayoutAuth.vue?vue&type=script&lang=js"
export * from "./LayoutAuth.vue?vue&type=script&lang=js"
import style0 from "./LayoutAuth.vue?vue&type=style&index=0&id=0c5f5a93&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports